<template>
  <div>
    <div class="page_title">常用回复</div>
    <div style="padding:20px;">
      <div class="container">
        <div class="box">
          <div class="title">
            <div class="item1">分组名称</div>
            <div class="item2">回复内容</div>
            <div class="item3">操作</div>
          </div>
          <div class="replyitem" v-for="(item,index) in list" :key="index">
            <div class="item1">{{item.type_name}}</div>
            <div class="item2 replyinfo">
              <div class="replyinfoitem" v-for="(i,ind) in item.reply_list" :key="ind">{{i}}</div>
            </div>
            <div class="item3">
              <el-button
                type="text"
                @click="editReply(item.type_id)"
                :disabled="module_id_array[0]?!module_id_array.includes('53'):false"
              >编辑</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import platform from "../../../api/platform";
import template from "../../../api/template";
export default {
  data() {
    return {
      list: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    getList() {
      template
        .replyList()
        .then(res => {
          if (res.code == 0) {
            this.list = res.data.list;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    editReply(type_id) {
      this.$router.push({
        path: "editreply",
        query: {
          type_id
        }
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.box {
  width: 100%;
  border: solid 1px #cfcece;
  text-align: left;
}
.title {
  padding: 0 40px 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 36px;
  font-weight: 600;
  font-size: 14px;
  background-color: #f7f8fa;
}
.item1 {
  width: 10%;
  font-weight: 600;
}
.item2 {
  width: 80%;
}
.item3 {
  width: 10%;
  text-align: right;
}
.replyitem {
  padding: 0 40px 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-bottom: solid 1px #e1e3e9;
  min-height: 74px;
}

.replyinfo {
  padding: 20px 0 10px;
  .replyinfoitem {
    margin-bottom: 10px;
    background-color: #f9f8ee;
    padding: 10px;
    box-sizing: border-box;
  }
}
</style>


